import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F5F4F0]">
      <div className="w-full max-w-md card-soft p-8 md:p-10 fade-in-up" data-testid="forgot-password-page">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#5C7A4F] text-white mb-4">
          <Mail size={22} />
        </div>
        <h2 className="font-heading text-3xl font-semibold text-[#2C342A]">Forgot your password?</h2>
        <p className="text-[#707A6E] mt-1 mb-8">
          Enter your email and we'll send you a link to reset it.
        </p>

        {sent ? (
          <div className="space-y-4" data-testid="forgot-sent-state">
            <div className="rounded-xl bg-emerald-500/10 text-emerald-800 px-4 py-3 text-sm">
              If <b>{email}</b> exists, we've emailed you a reset link. Check your inbox (and spam) — the link expires in 1 hour.
            </div>
            <Link to="/login" className="inline-flex items-center gap-2 text-[#5C7A4F] hover:underline">
              <ArrowLeft size={14} /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.18em] text-[#707A6E]">Email</label>
              <input required type="email" data-testid="forgot-email-input" value={email}
                     onChange={(e) => setEmail(e.target.value)}
                     className="mt-1 w-full rounded-xl border border-[#E4E2DC] bg-white px-4 py-3 outline-none focus:border-[#5C7A4F]" />
            </div>
            {error && <div className="text-sm text-[#C06E52] bg-[#C06E52]/10 rounded-xl px-3 py-2" data-testid="forgot-error">{error}</div>}
            <button data-testid="forgot-submit-btn" disabled={submitting}
                    className="w-full rounded-xl bg-[#5C7A4F] text-white px-6 py-3 font-medium hover:bg-[#4B6640] disabled:opacity-60">
              {submitting ? "Sending…" : "Send reset link"}
            </button>
            <p className="text-sm text-center mt-2">
              <Link to="/login" className="text-[#707A6E] hover:text-[#2C342A] hover:underline">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
